import { actionCopyEn } from "./actionCopy";

export const formPageCopyEn = {
    entryFor: (label) => `Entry for ${label}`,
    next: actionCopyEn.next,
    back: actionCopyEn.back,
    changingAnswers: "You are changing answers you have already given",
    submit: actionCopyEn.submit,
    startNow: "Start Now",
    startForm: "Start Form",
    startingForm: "Starting Form...",
    formSubmitted: "Form submitted",
    errorsOnPage: (count) => `Errors with ${count} question${count === 1 ? "" : "s"} on this page`,
    invalidValue: "Invalid value",
    groupTotal: (total, target) => `Total: ${total} of ${target}`,
    groupMustTotal: (target) => `These answers must add up to ${target}`,
    groupPlaced: (total, target) => `${total} of ${target} placed`,
    groupLeft: (n) => `${n} left`,
    groupOver: (n) => `${n} over`,
    groupComplete: (target) => `All ${target} placed`,
    countIncrease: (label) => `Add one to ${label}`,
    countDecrease: (label) => `Take one from ${label}`,
    countRequired: "Please enter a number, or 0 for none",
    answerTooHigh: "This number cannot be more than your earlier answer",
    exclusiveConflict: "This answer can't be combined with the other answers",
    tickAtLeastOne: "Please tick at least one answer",
    pageOf: (page, total) => `Page ${page} of ${total}`,
    carriedNote: "We've carried this forward from last time.",
    questionOf: (current, total) => `Question ${current} of ${total}`,
    questionsRange: (min, max) => `Questions ${min} to ${max}`,
    questionsRangeOf: (min, max, total) => `Questions ${min} to ${max} of ${total}`,
    formatProgressLabel: ({ min, max, total, pageNumber, pageTotal }) => {
        let questionPart: string;
        if (min === max) {
            questionPart = `Question ${min} of ${total}`;
        } else if (max === total) {
            questionPart = `Questions ${min} to ${max}`;
        } else {
            questionPart = `Questions ${min} to ${max} of ${total}`;
        }

        if (min === max && min === pageNumber && pageTotal === total) {
            return questionPart;
        }

        return `Page ${pageNumber} of ${pageTotal} - ${questionPart}`;
    },
};
